import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
	apiKey: "AIzaSyD5_HNRjtbideA0DEPAULXBdNyWq3_trJs",
	authDomain: "orbitist-edp.firebaseapp.com",
	databaseURL: "https://orbitist-edp.firebaseio.com",
	projectId: "orbitist-edp",
	storageBucket: "orbitist-edp.appspot.com",
	messagingSenderId: "1065905172961"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
	timestampsInSnapshots: true
}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const listsCollection = db.collection('lists')

export {
    db,
    auth,
    currentUser,
    usersCollection,
    postsCollection,
		listsCollection
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js